import { Button, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material'
import { Box, } from '@mui/system'
import React, { useState } from 'react'
import ReactHtmlTableToExcel from 'react-html-table-to-excel'
import { Item } from '../../../common/snippets'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import moment from 'moment'
import { callAddFontRobotoBold } from "../../../common/font/Roboto-bold"
import { callAddFontRobotoMedium } from "../../../common/font/Roboto-Medium-normal"
import { useEffect } from 'react'
import { userWiseExcelHeader } from '../analysisReport/constants'
import { focusElemnt, navigation3 } from '../../../common/helper'
const SummaryTable = ({ disableExcel, userDetail, tableData, loginData, reportView, selBranch, UserName, fromDate, toDate, transaction, paymentMode, paymentType, }) => {
    const [showTableData, setShowTableData] = useState([])
    const [searchResult, setSearchResult] = useState(true)
    const [state, setState] = useState({
        filter: false,
        generatePDF: false,
        load: false,
        buttonsShow: false,
    })
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    const { filter, generatePDF, load, buttonsShow } = { ...state }
    useEffect(() => {
        if (tableData?.length > 0) {
            groupData(tableData)
        } else {
            setShowTableData([])
        }
    }, [tableData])
    const groupData = (array) => {
        if (array.length >= 1) {
            var newData = {}
            let newArray = array?.map((item) => ({
                ...item, Transaction: `${item.TYPE === "Booking" ? "Booking (A)" : item.TYPE === "Delivery" ? "Delivery (B)" : item.TYPE === "Refund" ? "Refund (C)" : ""}`,
                TotalAmt: item.PaidAmt + item.PaidManAmt + item.TopayAmt + item.TopayManAmt + item.DDDVAmt + item.OnAccAmt + item.CODAmt + item.SelfAmt + item.FOCAmt
            }))
            newArray?.forEach((item) => {
                if (!(item['PaymentMode'] in newData)) {
                    newData[item['PaymentMode']] = []
                }
                newData[item['PaymentMode']].push({
                    CODAmt: item['CODAmt'],
                    DDDVAmt: item['DDDVAmt'],
                    FOCAmt: item['FOCAmt'],
                    OnAccAmt: item['OnAccAmt'],
                    PaidAmt: item['PaidAmt'],
                    PaidManAmt: item['PaidManAmt'],
                    PaymentMode: item['PaymentMode'],
                    Quantity: item['Quantity'],
                    SelfAmt: item['SelfAmt'],
                    TYPE: item['TYPE'],
                    TopayAmt: item['TopayAmt'],
                    TopayManAmt: item['TopayManAmt'],
                    TotalAmt: item['TotalAmt'],
                    Transaction: item['Transaction'],
                })
            })
            let totalPaidAmt = 0;
            let totalPaidManAmt = 0;
            let totalTopayAmt = 0;
            let totalTopayManAmt = 0;
            let totalDDDVAmt = 0;
            let totalOnAccAmt = 0;
            let totalCODAmt = 0;
            let totalSelfAmt = 0;
            let totalFOCAmt = 0;
            let totalAmt = 0;
            Object.keys(newData)?.map((val) => {
                newData[val].forEach((val) => {
                    if (val.TYPE === "Refund") {
                        totalPaidAmt = totalPaidAmt - Number(val.PaidAmt);
                        totalPaidManAmt = totalPaidManAmt - Number(val.PaidManAmt);
                        totalTopayAmt = totalTopayAmt - Number(val.TopayAmt);
                        totalTopayManAmt = totalTopayManAmt - Number(val.TopayManAmt);
                        totalDDDVAmt = totalDDDVAmt - Number(val.DDDVAmt);
                        totalOnAccAmt = totalOnAccAmt - Number(val.OnAccAmt);
                        totalCODAmt = totalCODAmt - Number(val.CODAmt);
                        totalSelfAmt = totalSelfAmt - Number(val.SelfAmt);
                        totalFOCAmt = totalFOCAmt - Number(val.FOCAmt);
                        totalAmt = totalAmt - Number(val.TotalAmt);
                    } else {
                        totalPaidAmt += Number(val.PaidAmt);
                        totalPaidManAmt += Number(val.PaidManAmt);
                        totalTopayAmt += Number(val.TopayAmt);
                        totalTopayManAmt += Number(val.TopayManAmt);
                        totalDDDVAmt += Number(val.DDDVAmt);
                        totalOnAccAmt += Number(val.OnAccAmt);
                        totalCODAmt += Number(val.CODAmt);
                        totalSelfAmt += Number(val.SelfAmt);
                        totalFOCAmt += Number(val.FOCAmt);
                        totalAmt += Number(val.TotalAmt);
                    }
                })

                newData[val]?.push({
                    Transaction: `Net Collection (A+B-C)`,
                    PaidAmt: totalPaidAmt,
                    PaidManAmt: totalPaidManAmt,
                    TopayAmt: totalTopayAmt,
                    TopayManAmt: totalTopayManAmt,
                    DDDVAmt: totalDDDVAmt,
                    OnAccAmt: totalOnAccAmt,
                    CODAmt: totalCODAmt,
                    SelfAmt: totalSelfAmt,
                    FOCAmt: totalFOCAmt,
                    TotalAmt: totalAmt.toFixed(2),
                    isTotal: true
                })
                newData[val]?.unshift({
                    Transaction: "Transactions",
                    PaidAmt: "Paid",
                    PaidManAmt: "Paid Manual",
                    TopayAmt: "ToPay",
                    TopayManAmt: "ToPay Manual",
                    DDDVAmt: "ToPay DDDV",
                    OnAccAmt: "On Account",
                    CODAmt: "COD",
                    SelfAmt: "Self Booking",
                    FOCAmt: "FOC",
                    TotalAmt: "Total Amount",
                    isHeading: true
                })
                newData[val]?.unshift({
                    Transaction: `Payment Mode: ${val}`,
                    TopayAmt: `State: ${userDetail?.[0]?.Statename}`,
                    DDDVAmt: `City Name: ${userDetail?.[0]?.Cityname}`,
                    SelfAmt: `Branch Name: ${userDetail?.[0]?.Branchname}`,
                    isSubHeading: true
                })
                totalPaidAmt = 0;
                totalPaidManAmt = 0;
                totalTopayAmt = 0;
                totalTopayManAmt = 0;
                totalDDDVAmt = 0;
                totalOnAccAmt = 0;
                totalCODAmt = 0;
                totalSelfAmt = 0;
                totalFOCAmt = 0;
                totalAmt = 0;
            })
            const mainData = { ...newData }
            let bodyData = []
            Object.keys(mainData)?.map((item) => {
                const refondData = mainData[item]?.map((val) => val?.TYPE === "Refund")
                if (!refondData?.includes(true)) {
                    const userData = [...mainData[item]]
                    const obj = {
                        Transaction: `Refund (c)`,
                        PaidAmt: 0,
                        PaidManAmt: 0,
                        TopayAmt: 0,
                        TopayManAmt: 0,
                        DDDVAmt: 0,
                        OnAccAmt: 0,
                        CODAmt: 0,
                        SelfAmt: 0,
                        FOCAmt: 0,
                        TotalAmt: 0,
                    }
                    mainData[item].splice((userData?.length - 1), 0, obj);
                }
                const data = [...bodyData]
                bodyData = [...data, ...mainData[item]]
            })
            //   if()
            bodyData?.forEach((val) => {
                if (val.isTotal) {
                    totalPaidAmt += Number(val.PaidAmt);
                    totalPaidManAmt += Number(val.PaidManAmt);
                    totalTopayAmt += Number(val.TopayAmt);
                    totalTopayManAmt += Number(val.TopayManAmt);
                    totalDDDVAmt += Number(val.DDDVAmt);
                    totalOnAccAmt += Number(val.OnAccAmt);
                    totalCODAmt += Number(val.CODAmt);
                    totalSelfAmt += Number(val.SelfAmt);
                    totalFOCAmt += Number(val.FOCAmt);
                    totalAmt += Number(val.TotalAmt);
                }
            })
            bodyData?.push({
                Transaction: `All Total Collection (A+B-C)`,
                PaidAmt: totalPaidAmt,
                PaidManAmt: totalPaidManAmt,
                TopayAmt: totalTopayAmt,
                TopayManAmt: totalTopayManAmt,
                DDDVAmt: totalDDDVAmt,
                OnAccAmt: totalOnAccAmt,
                CODAmt: totalCODAmt,
                SelfAmt: totalSelfAmt,
                FOCAmt: totalFOCAmt,
                TotalAmt: totalAmt.toFixed(2),
                isTotal: true
            })
            bodyData?.unshift({ Transaction: `Summary View (${UserName})`, isSupHeading: true })
            setShowTableData(bodyData)
            //   return bodyData;
        } else {
            setShowTableData([])
        }
    }

    const printClick = (isSave) => {
        setState({ ...state, load: true, generatePDF: true })
        jsPDF.API.events.push(["addFonts", callAddFontRobotoBold]);
        jsPDF.API.events.push(["addFonts", callAddFontRobotoMedium]);

        const HeaderColumn = [
            {
                headerName: 'Branch',
                exportHead: 'Branch',
                field: 'Branch',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'User',
                exportHead: 'User',
                field: 'User',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Transaction Type',
                exportHead: 'Transaction Type',
                field: 'TransactionType',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Payment Type',
                exportHead: 'Payment Type',
                field: 'PaymentType',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Payment Mode',
                exportHead: 'Payment Mode',
                field: 'PaymentMode',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
        ]
        const columnDefs = [
            {
                headerName: 'Transactions',
                exportHead: '',
                field: 'Transaction',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Paid',
                exportHead: 'Paid',
                field: 'PaidAmt',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Paid Manual',
                exportHead: 'Paid Manual',
                field: 'PaidManAmt',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'ToPay',
                exportHead: 'ToPay',
                field: 'TopayAmt',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'ToPay Manual',
                exportHead: 'ToPay Manual',
                field: 'TopayManAmt',
                xlCol: { dataType: 'quantity', dataFormatter: null },
            },
            {
                headerName: 'ToPay DDDV',
                exportHead: 'ToPay DDDV',
                field: 'DDDVAmt',
                xlCol: { dataType: 'quantity', dataFormatter: null },
            },
            {
                headerName: 'On Account',
                exportHead: 'On Account',
                field: 'OnAccAmt',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'COD',
                exportHead: 'COD',
                field: 'CODAmt',
                xlCol: { dataType: 'string', dataFormatter: null },
            },
            {
                headerName: 'Self Booking',
                exportHead: 'Self Booking',
                field: 'SelfAmt',
                xlCol: { dataType: 'quantity', dataFormatter: null },
            },
            {
                headerName: 'FOC',
                exportHead: 'FOC',
                field: 'FOCAmt',
                xlCol: { dataType: 'quantity', dataFormatter: null },
            },
            {
                headerName: 'Total Amount',
                exportHead: 'Total Amount',
                field: 'TotalAmt',
                xlCol: { dataType: 'quantity', dataFormatter: null },
            },
        ]

        const pdfColumns = columnDefs.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const HeaderColumns = HeaderColumn.map((col) => {
            return { header: col.exportHead, dataKey: col.field, xlCol: col.xlCol }
        })
        const HeaderData = [
            {
                Branch: selBranch?.BranchName,
                User: UserName,
                TransactionType: transaction?.Transactions,
                PaymentType: paymentType?.name,
                PaymentMode: paymentMode?.ModeName
            },
        ]
        const doc = new jsPDF({ orientation: 'p', format: [1239, 1754], unit: 'px', compress: true })

        var totalPagesExp = '{total_pages_count_string}'
        const jsPdfHeaderFooter = (data, userData, totalPagesExp) => {
            const doc = data.doc
            // Footer
            var pageSize = doc.internal.pageSize
            var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight()
            var pageWidth = pageSize.width ? pageSize.width : pageSize.getWidth()

            var str = 'Page : ' + doc.internal.getNumberOfPages()
            if (typeof doc.putTotalPages === 'function') {
                str = str + ' of ' + totalPagesExp
            }
            doc.setFontSize(16)
            doc.text(str, doc.internal.pageSize.width - data.settings.margin.left + 130, pageHeight - 5, "right")
            doc.setFont('Roboto', 'bold')
            doc.text(`Report By : ${userData.strUserName} [ ${userData.strBranchName} ]`, 30, pageHeight - 5)
            doc.text(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`, (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth(`Report Time : ${moment(new Date()).format('DD MMM YYYY, ddd, HH:mm')}`) * doc.internal.getFontSize() / 2) + 90, pageHeight - 5)
        }

        let drawCell = function (data) {
            var rows = data.table.body
            rows.map((val) => {
                if (val.raw.isSupHeading) {
                    val.cells[0].colSpan = 11
                    val.cells[0].styles.font = 'Roboto'
                    val.cells[0].styles.fontStyle = 'normal'
                    val.cells[0].styles.fontSize = '16'
                    val.cells[0].styles.textColor = [0, 0, 0]
                    val.cells[0].styles.halign = 'left'
                    val.cells[0].styles.fillColor = [191, 225, 255]
                }
                if (Object.keys(val.raw).length == 5) {
                    val.cells[0].colSpan = 3
                    val.cells[0].styles.font = 'Roboto'
                    val.cells[0].styles.fontStyle = 'normal'
                    val.cells[0].styles.fontSize = '16'
                    val.cells[0].styles.textColor = [0, 0, 0]
                    val.cells[0].styles.halign = 'left'
                    val.cells[0].styles.fillColor = [233, 245, 255]
                    val.cells[3].colSpan = 2
                    val.cells[3].styles.font = 'Roboto'
                    val.cells[3].styles.fontStyle = 'normal'
                    val.cells[3].styles.fontSize = '16'
                    val.cells[3].styles.textColor = [0, 0, 0]
                    val.cells[3].styles.halign = 'left'
                    val.cells[3].styles.fillColor = [233, 245, 255]
                    val.cells[5].colSpan = 3
                    val.cells[5].styles.font = 'Roboto'
                    val.cells[5].styles.fontStyle = 'normal'
                    val.cells[5].styles.fontSize = '16'
                    val.cells[5].styles.textColor = [0, 0, 0]
                    val.cells[5].styles.halign = 'left'
                    val.cells[5].styles.fillColor = [233, 245, 255]
                    val.cells[8].colSpan = 3
                    val.cells[8].styles.font = 'Roboto'
                    val.cells[8].styles.fontStyle = 'normal'
                    val.cells[8].styles.fontSize = '16'
                    val.cells[8].styles.textColor = [0, 0, 0]
                    val.cells[8].styles.halign = 'left'
                    val.cells[8].styles.fillColor = [233, 245, 255]
                }
                if (val.raw.isTotal) {
                    for (let i = 0; i <= 10; i++) {
                        val.cells[i].colSpan = 1
                        val.cells[i].styles.font = 'Roboto'
                        val.cells[i].styles.fontStyle = 'normal'
                        val.cells[i].styles.fontSize = '16'
                        val.cells[i].styles.textColor = [0, 0, 0]
                        val.cells[i].styles.halign = i == 0 ? "left" : 'right'
                        val.cells[i].styles.fillColor = [238, 238, 238]
                    }
                }
                if (val.raw.isHeading) {
                    for (let i = 0; i <= 10; i++) {
                        val.cells[i].colSpan = 1
                        val.cells[i].styles.font = 'Roboto'
                        val.cells[i].styles.fontStyle = 'normal'
                        val.cells[i].styles.fontSize = '16'
                        val.cells[i].styles.textColor = [0, 0, 0]
                        val.cells[i].styles.halign = i == 0 ? "left" : 'right'
                        val.cells[i].styles.fillColor = [218, 237, 254]
                    }
                }
            })
        }

        doc.setProperties({
            title: `User Wise Collection.pdf`,
            subject: 'User Wise Collection Report',
            author: 'Maven Tech Labs Pvt. Ltd.',
            keywords: 'maven tech, Cargo system, Receive',
            creator: 'MTLPL',
        })

        autoTable(doc, {
            margin: { top: 60, left: 30, right: 30, bottom: 5 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: HeaderColumns,
            body: HeaderData,
            columnStyles: {
                0: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                1: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                2: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                3: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
                4: { fontSize: 18, valign: "middle", font: 'Roboto', fontStyle: "normal", cellPadding: 12, minCellHeight: 36, halign: 'left', textColor: [0, 0, 0] },
            },
            theme: 'grid',
            startY: 160,
            headStyles: {
                fillColor: [191, 225, 255],
                textColor: [0, 0, 0],
                minCellHeight: 36,
                valign: 'middle',
                cellPadding: 12,
                fontSize: 18,
                font: 'Roboto',
                fontStyle: 'normal',
                lineWidth: 0.6,
            },
            didDrawPage: function (data) {
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(18).setFont('Roboto', 'bold')
                doc.text(`Collection Date: ${moment(fromDate).format("DD-MMM-YYYY")} To ${moment(toDate).format("DD-MMM-YYYY")} `, data.settings.margin.left, 150)
                doc.text(`Report View: Summary`, doc.internal.pageSize.width - data.settings.margin.left, 150, "right")
            },
        })

        autoTable(doc, {
            margin: { top: 120, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            headStyles: {
                fillColor: [191, 225, 255],
                fontSize: 16,
                minCellHeight: 36,
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'normal',
                font: 'Roboto',
                textColor: [0, 0, 0]
            },
            tableLineWidth: 0.6,
            columns: pdfColumns,
            body: showTableData,
            styles: {
                lineWidth: [0, 0.2, 0, 0.2]
            },
            columnStyles: {
                0: { halign: 'left', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
                1: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
                2: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
                3: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
                4: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
                5: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
                6: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
                7: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
                8: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
                9: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
                10: { halign: 'right', minCellHeight: 36, fontSize: 16, cellPadding: 6, valign: "middle", fontStyle: "normal", font: 'Roboto', textColor: [0, 0, 0] },
            },
            theme: 'grid',
            showHead: "never",
            didParseCell: (data) => {
                drawCell(data)
            },
            didDrawPage: function (data) {
                doc.setTextColor(40)
                doc.addImage('/images/logo-66.png', 'JPEG', 30, 50, 50, 50)
                doc.setFontSize(26).setFont("Roboto", 'bold')
                doc.setTextColor(16, 79, 162)
                doc.text('Cargo System | Userwise Collection Report', 30 + 60, 80)
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(22).setFont("Roboto", 'bold')
                doc.text(`Company Name :${loginData.strCompanyName}`, doc.internal.pageSize.width - data.settings.margin.left, 80, "right")
                jsPdfHeaderFooter(data, loginData, totalPagesExp)
            },
        })
        doc.setFont('Roboto')

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`UserWiseCollectionWithDeliveryExpense Report ${currentDateTime}.pdf`)
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                const pdfUrl = doc.output('bloburl')
                document.getElementById('userWiseSammaryoutput').data = pdfUrl
                // document.getElementById('userWiseSammaryoutput').data = doc.output('datauristring', 'UserWiseCollectionWithDeliveryExpense..pdf')
                focusElemnt("UWBackBtn")
            }, 2000)
        } else {
            setTimeout(() => {
                setState({ ...state, generatePDF: false, load: true })
                const pdfUrl = doc.output('bloburl')
                document.getElementById('userWiseSammaryoutput').data = pdfUrl
                // document.getElementById('userWiseSammaryoutput').data = doc.output('datauristring', 'UserWiseCollectionWithDeliveryExpense..pdf')
                focusElemnt("UWBackBtn")
            }, 2000)
        }

    }

    const InsideRowContent = ({ item, index, fontVal }) => {
        return (
            <TableRow className="receivedTr" key={index}>
                {item?.isSubHeading ?
                    <>
                        <TableCell className="userWiseReportSubHeading" style={{ fontSize: fontVal, position: "sticky", top: "33px", padding: "10px 15px", backgroundColor: '#F2F9FF', fontWeight: 700, color: "#444444" }} colSpan={3}>{item?.Transaction}</TableCell>
                        <TableCell className="userWiseReportSubHeading" style={{ fontSize: fontVal, position: "sticky", top: "33px", padding: "10px 15px", backgroundColor: '#F2F9FF', fontWeight: 700, color: "#444444" }} colSpan={2}>{item?.TopayAmt}</TableCell>
                        <TableCell className="userWiseReportSubHeading" style={{ fontSize: fontVal, position: "sticky", top: "33px", padding: "10px 15px", backgroundColor: '#F2F9FF', fontWeight: 700, color: "#444444", textAlign: "center" }} colSpan={3}>{item?.DDDVAmt} </TableCell>
                        <TableCell className="userWiseReportSubHeading" style={{ fontSize: fontVal, position: "sticky", top: "33px", padding: "10px 15px", textAlign: "right", backgroundColor: '#F2F9FF', fontWeight: 700, color: "#444444" }} colSpan={3}>{item?.SelfAmt}</TableCell>
                    </> :
                    item.isHeading ?
                        <>
                            <TableCell className="userWiseReportHeading" style={{ fontSize: fontVal, position: "sticky", top: "65px", textAlign: "left", color: "#444444", backgroundColor: "#DAEDFE", }}>{item?.Transaction}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ fontSize: fontVal, position: "sticky", top: "65px", textAlign: "right", color: "#444444", backgroundColor: "#DAEDFE", }}>{item?.PaidAmt}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ fontSize: fontVal, position: "sticky", top: "65px", textAlign: "right", color: "#444444", backgroundColor: "#DAEDFE", }}>{item?.PaidManAmt}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ fontSize: fontVal, position: "sticky", top: "65px", textAlign: "right", color: "#444444", backgroundColor: "#DAEDFE", }}>{item?.TopayAmt}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ fontSize: fontVal, position: "sticky", top: "65px", textAlign: "right", color: "#444444", backgroundColor: "#DAEDFE", }}>{item?.TopayManAmt}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ fontSize: fontVal, position: "sticky", top: "65px", textAlign: "right", color: "#444444", backgroundColor: "#DAEDFE", }}>{item?.DDDVAmt}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ fontSize: fontVal, position: "sticky", top: "65px", textAlign: "right", color: "#444444", backgroundColor: "#DAEDFE", }}>{item?.OnAccAmt}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ fontSize: fontVal, position: "sticky", top: "65px", textAlign: "right", color: "#444444", backgroundColor: "#DAEDFE", }}>{item?.CODAmt}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ fontSize: fontVal, position: "sticky", top: "65px", textAlign: "right", color: "#444444", backgroundColor: "#DAEDFE", }}>{item?.SelfAmt}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ fontSize: fontVal, position: "sticky", top: "65px", textAlign: "right", color: "#444444", backgroundColor: "#DAEDFE", }}>{item?.FOCAmt}</TableCell>
                            <TableCell className="userWiseReportHeading" style={{ fontSize: fontVal, position: "sticky", top: "65px", textAlign: "right", color: "#444444", backgroundColor: "#DAEDFE", }}>{item?.TotalAmt}</TableCell>
                            {/* {heading?.map((val) => <TableCell className="userWiseReportHeading" style={{ textAlign: val.align, backgroundColor: 'rgb(213, 236, 254)' }}>{val?.val}</TableCell>)} */}
                        </>
                        :
                        item?.isTotal ?
                            <>
                                <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ paddingLeft: "10px", fontWeight: "700", fontSize: fontVal, backgroundColor: "#eeeeee", height: "36px" }}>{item?.Transaction}</TableCell>
                                <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight: "700", fontSize: fontVal, backgroundColor: "#eeeeee", height: "36px" }}>{item?.PaidAmt}</TableCell>
                                <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight: "700", fontSize: fontVal, backgroundColor: "#eeeeee", height: "36px" }}>{item?.PaidManAmt}</TableCell>
                                <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight: "700", fontSize: fontVal, backgroundColor: "#eeeeee", height: "36px" }}>{item?.TopayAmt}</TableCell>
                                <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight: "700", fontSize: fontVal, backgroundColor: "#eeeeee", height: "36px" }}>{item?.TopayManAmt}</TableCell>
                                <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight: "700", fontSize: fontVal, backgroundColor: "#eeeeee", height: "36px" }}>{item?.DDDVAmt}</TableCell>
                                <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight: "700", fontSize: fontVal, backgroundColor: "#eeeeee", height: "36px" }}>{item?.OnAccAmt}</TableCell>
                                <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight: "700", fontSize: fontVal, backgroundColor: "#eeeeee", height: "36px" }}>{item?.CODAmt}</TableCell>
                                <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight: "700", fontSize: fontVal, backgroundColor: "#eeeeee", height: "36px" }}>{item?.SelfAmt}</TableCell>
                                <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight: "700", fontSize: fontVal, backgroundColor: "#eeeeee", height: "36px" }}>{item?.FOCAmt}</TableCell>
                                <TableCell className="userWiseReportSubTotal" colSpan={1} style={{ textAlign: "right", fontWeight: "700", fontSize: fontVal, backgroundColor: "#eeeeee", height: "36px" }}>{item?.TotalAmt}</TableCell>
                            </>
                            : item?.isSupHeading ? "" :
                                <>
                                    <TableCell className="userwiseTD" colSpan={1} style={{ paddingLeft: "10px", fontSize: fontVal, borderRight: "none" }}>{item?.Transaction}</TableCell>
                                    <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal }}>{item?.PaidAmt} </TableCell>
                                    <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal }}>{item?.PaidManAmt} </TableCell>
                                    <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal }}>{item?.TopayAmt}</TableCell>
                                    <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal }}>{item?.TopayManAmt}</TableCell>
                                    <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal }}>{item?.DDDVAmt}</TableCell>
                                    <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal }}>{item?.OnAccAmt}</TableCell>
                                    <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal }}>{item?.CODAmt}</TableCell>
                                    <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal }}>{item?.SelfAmt}</TableCell>
                                    <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal }}>{item?.FOCAmt}</TableCell>
                                    <TableCell className="userwiseTD" colSpan={1} style={{ textAlign: "right", fontSize: fontVal }}>{item?.TotalAmt}</TableCell>
                                </>
                }
            </TableRow>
        )
    }

    return (
        <>
            <Stack style={{ margin: "0px 10px", marginRight: "0px" }}>
                <Item className='userReport'>
                    <Item className='userReport-heading'>
                        Report For: Userwise Collection Report
                    </Item>
                    <Item className='userReport-buttons'>
                        {searchResult ? <>
                            {disableExcel ?
                                <Box>
                                    <Button variant="outlined" className="userWisereporttembtn" disabled={true}>Export to Excel</Button>
                                </Box>
                                :
                                <Box onKeyDown={(e) => navigation3(e, "UWExpToPdfBtn", "UWSplitButton", () => { })}>
                                    <ReactHtmlTableToExcel
                                        id="UWExpToExsl"
                                        className="userWisereporttemExcelBtn"
                                        table="table-userWiseSummaryReport-xls"
                                        filename={`Userwise Collection Report ${currentDateTime}`}
                                        sheet="tablexls"
                                        buttonText="Export to Excel"
                                    />
                                </Box>}
                            <Box>
                                <Button id="UWExpToPdfBtn" variant="outlined" className="userWisereporttembtn"
                                    onClick={() => { setSearchResult(false); printClick(true) }}
                                    onKeyDown={(e) => navigation3(e, "UWPrintPdfBtn", disableExcel ? "UWSplitButton" : "UWExpToExsl", () => { setSearchResult(false); printClick(true) })}
                                >
                                    Export to Pdf
                                </Button>
                            </Box>
                            <Box>
                                <Button id="UWPrintPdfBtn"
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => { setSearchResult(false); printClick(false) }}
                                    onKeyDown={(e) => navigation3(e, "UWFromDate", "UWExpToPdfBtn", () => { setSearchResult(true); printClick(false) })}
                                >
                                    Print
                                </Button>
                            </Box>
                        </> : <>
                            <Box>
                                <Button id="UWBackBtn"
                                    variant="outlined"
                                    className="userWisereporttembtn"
                                    onClick={() => setSearchResult(true)}
                                    onKeyDown={(e) => navigation3(e, "UWFromDate", "UWSplitButton", () => { setSearchResult(true); focusElemnt("UWSplitButton") })}
                                >
                                    Back
                                </Button>
                            </Box>
                        </>}

                    </Item>
                </Item>
            </Stack>
            {
                searchResult ?
                    <Stack sx={{ marginLeft: 2, marginRight: 1, height: 470 }} className="scroll">
                        <TableContainer className="lr-popup-table lrModel " component={Paper} style={{ borderRadius: "6px" }}>
                            <Table size="small" aria-label="a dense table">
                                <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                                    <TableRow className='sammary-heading'>
                                        <TableCell colSpan={11} style={{ fontSize: "12px", fontWeight: "900", paddingLeft: "10px", backgroundColor: "#BFE1FF", color: "#444444", textAlign: "left" }}>Summary View ({UserName})</TableCell>
                                    </TableRow>
                                </TableHead>
                                {showTableData?.length < 1 ? (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={11}>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            marginTop: '20px',
                                                            marginBottom: '20px',
                                                            color: 'red',
                                                            fontSize: '14px',
                                                        }}
                                                    >
                                                        <span>No results found. Please refine your search parameters and search again.</span>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                ) : showTableData.length > 1 ? (
                                    <TableBody className="filter-data-row" style={{ border: "none" }}>
                                        {showTableData?.map((item, index) => (
                                            <InsideRowContent item={item} index={index} key={index} fontVal={"12px"} />
                                        ))}
                                    </TableBody>
                                ) : (
                                    ''
                                )}
                            </Table>
                            <Table id="table-userWiseSummaryReport-xls" size="small" aria-label="a dense table" style={{ display: "none" }}>
                                <TableHead style={{ fontWeight: 'bold' }}>
                                    <TableRow>
                                        <TableCell className="reportTD" style={{ fontSize: '30px', fontWeight: '600', textAlign: 'left' }} colSpan={6}>
                                            <h4 style={{ paddingLeft: '5px' }}>Report For: Userwise Collection Report</h4>
                                        </TableCell>
                                        <TableCell className="reportTD" style={{ fontSize: '30px', fontWeight: '600', textAlign: 'left' }} colSpan={5}>
                                            <h4 style={{ paddingLeft: '5px' }}>Company Name : {loginData?.strCompanyName}</h4>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow>
                                        <TableCell colSpan={11}></TableCell>
                                    </TableRow>
                                    <TableRow style={{ color: 'white' }}>
                                        {userWiseExcelHeader?.map((item, i) =>
                                            <TableCell
                                                style={{ backgroundColor: '#e5f3ff', color: "#444444", fontSize: '20px', fontWeight: '600', textAlign: 'left' }}
                                                colSpan={item.col}
                                                key={i}
                                            >
                                                {item.value}
                                            </TableCell>
                                        )}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={1}
                                        >
                                            <span>{moment(fromDate).format('MM/DD/YYYY')}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={1}
                                        >
                                            <span>{moment(toDate).format('MM/DD/YYYY')}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{selBranch?.BranchName}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{UserName}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={2}
                                        >
                                            <span>{transaction?.Transactions}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={1}
                                        >
                                            <span>{paymentType?.name}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={1}
                                        >
                                            <span>{paymentMode?.ModeName}</span>
                                        </TableCell>
                                        <TableCell
                                            className="reportTD"
                                            style={{ fontSize: '20px', fontWeight: '500', textAlign: 'left' }}
                                            colSpan={1}
                                        >
                                            <span>Summary</span>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableHead style={{ position: `sticky`, top: `0`, background: `white` }}>
                                    <TableRow className='sammary-heading'>
                                        <TableCell colSpan={11} style={{ fontSize: "20px", fontWeight: "900", backgroundColor: "#BFE1FF", color: "#444444", textAlign: "left" }}>Summary View ({UserName})</TableCell>
                                    </TableRow>
                                </TableHead>
                                {showTableData?.length < 1 ? (
                                    <>
                                        <TableBody>
                                            <TableRow>
                                                <TableCell colSpan={11}>
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            justifyContent: 'center',
                                                            marginTop: '20px',
                                                            marginBottom: '20px',
                                                            color: 'red',
                                                            fontSize: '14px',
                                                        }}
                                                    >
                                                        <span>No results found. Please refine your search parameters and search again.</span>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        </TableBody>
                                    </>
                                ) : showTableData.length > 1 ? (
                                    <TableBody className="filter-data-row" style={{ border: "none" }}>
                                        {showTableData?.map((item, index) => (
                                            <InsideRowContent item={item} index={index} key={index} fontVal={"20px"} />
                                        ))}
                                    </TableBody>
                                ) : (
                                    ''
                                )}
                            </Table>
                        </TableContainer>
                    </Stack>
                    :
                    <>
                        {generatePDF ? <div className={'generatePDF'}>Generating PDF....</div> : ''}
                        {load ? (
                            <object
                                id="userWiseSammaryoutput"
                                type="application/pdf"
                                width={"100%"}
                                height="440"
                                title="MTLPL -Cargo System - After Transfer Summary Report"
                                aria-label="MTLPL -Cargo System - After Transfer Summary Report"
                            ></object>
                        ) : (
                            ''
                        )}
                    </>
            }

        </>
    )
}

export default SummaryTable